import React from 'react';
import Comment from './Comment';
import CommentForm from './CommentForm';
import {connect} from "react-redux";
import {withStyles} from '@material-ui/core/styles';
import {actions} from "../../actions";
import {ROLES, withRoles} from "../Permissions";
import {ListItem,List} from '@material-ui/core';


const styles = theme => ({
    listDiv: {
        maxHeight:'200px',
        overflow:'auto'
    },
    listItem: {
        paddingLeft:0,
        paddingRight:0,
        whiteSpace:'pre-line'
    }
});

class CommentList extends React.Component{
    constructor(props){
        super(props);
        this.state= {
            comments: [],
            isReviewer:false,
        }
    }

    getReviewerData(){
        let reviewer_unid;
        const assessment_id = this.props.form._id;
        const reviewer = this.props.reviewers.find(reviewer=>reviewer.unid===this.props.user.unid);
        if(typeof reviewer != 'undefined'){
            reviewer_unid=reviewer.unid
        }
        return{
            assessment_id,
            reviewer_unid,
        }
    }

    addComment =(commentData)=>{
        const {assessment_id,reviewer_unid} = this.getReviewerData();
        const body = {comment:commentData, author: this.props.user.display_name, unid:this.props.user.unid};
        this.props.updateReviewerComments(body, assessment_id, this.props.user.unid).then(()=>{
            this.props.fetchReviewerComments(assessment_id,reviewer_unid).then(()=>{
                this.setState({
                    comments: this.props.comments
                })
            })
        })
    }

    editComment = (Index, editedData)=>{
        const {assessment_id} = this.getReviewerData();
        const commentId = this.state.comments[Index]._id;
        const body = {commentId,comment:editedData};
        this.state.comments[Index].comment = editedData;
        this.setState({
            comments:this.state.comments
        })
        this.props.updateReviewerComments(body, assessment_id, this.props.user.unid);
    }

    deleteComment = (Index) =>{
        const {assessment_id} = this.getReviewerData();
        const commentId = this.state.comments[Index]._id;
        delete this.state.comments[Index];
        this.setState({
            comments: this.state.comments
        });
        this.props.deleteReviewerComment(assessment_id,this.props.user.unid,commentId);
    }

    renderComment=(key)=>{
        return (
            <ListItem key={key} className = {this.props.classes.listItem}>
                <Comment key={key}
                         index={key}
                         details={this.state.comments[key]}
                         isReview={this.props.isReview}
                         isReviewer = {this.state.isReviewer}
                         editComment={this.editComment}
                         deleteComment={this.deleteComment}
                />
            </ListItem>
        )
    }

    componentDidMount(){
        const {assessment_id, reviewer_unid} = this.getReviewerData();
        // render comments only if viewer matches one of the reviewers
        // const reviewer_unid = null;
        if(this.props.isReview && reviewer_unid != undefined){
            console.log('fetch specific reviewer comments')
            this.props.fetchReviewerComments(assessment_id, reviewer_unid).then(()=>{
                this.setState({
                    comments:this.props.comments,
                    isReviewer:true
                })
            });
        }else if(!this.props.isReview){
            console.log('fetch all comments');
            this.props.fetchReviewerComments(assessment_id).then(()=>{
                this.setState({
                    comments:this.props.comments
                })
            });
        }
    }

    renderForm(){
        //only reviewer will see comment add form in review page - visible to anybody that has access to assessment view
        if((this.state.isReviewer && this.props.isReview) || !this.props.isReview){
            return(
                <div>
                    <CommentForm addComment={this.addComment}/>
                </div>
            )
        }else{
            return
        }
    }

    render(){
        return(
            <div>
                {this.renderForm()}
                <div className={this.props.classes.listDiv}>
                    <List>
                        {
                            this.state.comments.map((comment,index)=>(
                                this.renderComment(index)
                            ))
                        }
                    </List>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        reviewers: state.reviewers,
        assessments: state.assessments,
        form: state.newAssessmentForm,
        comments: state.comments
    };
}

export default connect(mapStateToProps, actions)(withStyles(styles)(withRoles([ROLES.COORDINATOR,ROLES.DEPARTMENTCOORDINATOR, ROLES.ADMIN, ROLES.REVIEWER])(CommentList)));
